exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity-select[data-v-0d7d08f8] {\n  max-width: inherit;\n}\n.quantity-select .quantity-select-action[data-v-0d7d08f8] {\n  padding: 12px .98rem 13px;\n}\nbutton[data-v-0d7d08f8] {\n  border-left-width: 0;\n  height: 48px;\n  width: 48px;\n}\ninput[data-v-0d7d08f8]:disabled {\n  background-color: #bdbdbd;\n}\ninput[type='number'][data-v-0d7d08f8] {\n  width: calc(100% - 96px);\n  min-width: 30px;\n  -moz-appearance: textfield;\n}\ninput[type='number'][data-v-0d7d08f8]::-webkit-inner-spin-button, input[type='number'][data-v-0d7d08f8]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);

// exports
